// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ProviderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ERR_MOD_PROVIDER_CONF, SUC_MOD_PROVIDER_CONF } from '../../../../utils/strings';

const useArchiveAndCreateProviderConfiguration = () => {
  return useExerciseSubmission(
    ProviderService.ProviderService_ArchiveAndCreateProviderConfiguration,
    SUC_MOD_PROVIDER_CONF,
    ERR_MOD_PROVIDER_CONF,
  );
};

export default useArchiveAndCreateProviderConfiguration;
